import { normalizeLoanType } from '~/libs/loan-product-info'

export function getApprovalOption(approval, initialChange) {
  const optionId = initialChange(approval)?.optionId || null;
  let optionIndex = approval.options?.findIndex(option => option.id === optionId) || 0;
  if (optionIndex < 0) {
    optionIndex = 0;
  }
  return approval.options?.[optionIndex] ?? {};
}

export function getApprovalMaxAmount(approval, option) {
  switch (normalizeLoanType(approval?.loanProductCategoryType)) {
    case 'ach':
      return option?.maxAmount
    case 'loc':
      return option?.limits?.drawAmount?.max
    case 'term':
      return option?.limits?.amount?.max
    case 'sba':
      return option?.limits?.amount?.max
    default:
      return option?.limits?.amount?.max
  }
}

export function normalizeTermType(termType) {
  switch (termType)  {
    case 'weeks':
      return 'weeks'
    case 'days':
      return 'days'
    default:
      return 'months'
  }
}

